// extracted by mini-css-extract-plugin
export default {"card-tilt":"styles-module_card-tilt---dSY2M"};